import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SocialLink } from '@bd/bdcore-utilities';
import ContactModal from './ContactModal';
import { colors } from '../styles';

const styles = css`
.Footer_content {
  font-size: 14px;
  padding: 40px 0 0 0;
  background-color: #EEEEEE;
  text-align: center;
  @media (min-width: 992px) {
    text-align: left;
    padding: 40px 0 0 0;
  }
}
.Footer_logo {
  width: 50%;
  display: block;
  margin: 0 auto 15px auto;
}
.Footer_socialLinks {
  padding: 0;
  margin: 30px 0;
  text-align: center;
  li {
    display: inline-block;
    margin: 0 0 0 20px;
    a img {
      height: 20px;
      width: auto;
      filter: brightness(80%);
    }
  }
  @media (min-width: 992px) {
    text-align: right;
  }
}
.Footer_menu {
  display: none;
  @media (min-width: 992px) {
    display: inline-block;
    padding: 0;
    margin: 0 20px 50px 0;
    vertical-align: top;
    list-style: none;
    li {
      font-weight: 400;
      line-height: 24px;
      a {
        color: #333333;
        font-weight: 400;
      }
    }
    .menu-heading {
      color: ${colors.color2};
      font-weight: 700;
    }
  }
  @media (min-width: 1201px) {
    margin: 0 50px 50px 0;
  }
}
.Footer_contactInfo {
  text-align: center;
  color: #333333;
  a {
    color: #333333;
  }
}
.Footer_EHOLogo {
  display: block;
  margin: 10px auto;
  @media (min-width: 992px) {
    display: inline-block;
    margin: -4px 0 0 10px;
    height: 18px;
    width: auto;
  }
}
.Footer_copyright {
  text-align: center;
  padding: 20px 30px;
  background-color: #232323;
  margin: 20px 0 0 0;
  color: #FFFFFF;
  a {
    color: ${colors.color2};
  }
}
`;

function Footer({ builder }) {
  return (
    <div className={styles}>
      <div className="Footer_wrapper">
        <div className="Footer_inner">
          <div className="Footer_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mx-auto text-center">
                  <p className="Footer_contactInfo">
                    <img className="Footer_logo" src="/images/hbt-logo.svg" alt={get(builder, 'name')} />
                    June 25-26, 2020<br />
                    <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a>
                  </p>
                  <ContactModal builder={builder}>
                    <div className="btn" role="button" tabIndex="0" >Questions? Contact Us</div>
                  </ContactModal>
                  <ul className="Footer_socialLinks">
                    {
                      get(builder, 'socialLinks', []).map(link => (
                        <li key={link}>
                          <SocialLink
                            url={link}
                          />
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            </div>
            <div className="Footer_copyright">
              &copy;{(new Date()).getFullYear()} {get(builder, 'name')}. All Rights Reserved.
              Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js